"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapeRegExp = escapeRegExp;
exports.flatten = flatten;
exports.getLocationSearchParams = getLocationSearchParams;
exports.noop = exports.getTimestamp = void 0;
exports.urlTransformer = urlTransformer;
/**
 * Returns undefined.
 * @returns {undefined}
 */
var noop = exports.noop = function noop() {
  return undefined;
};

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`. (Pulled from lodash)
 * @param string {String} The string to escape.
 * @returns {String} Returns the escaped string.
 */
function escapeRegExp(string) {
  var regExpChar = /[\\^$.*+?()[\]{}|]/g;
  var hasRegExpChar = RegExp(regExpChar.source);
  return string && hasRegExpChar.test(string) ? string.replace(regExpChar, '\\$&') : string;
}

/**
 * Get the location search params.
 * @returns {URLSearchParams}
 */
function getLocationSearchParams() {
  if (typeof window === 'undefined') {
    return new URLSearchParams();
  }
  return new URLSearchParams(window.location.search);
}

/**
 * Get a timestamp.
 * @returns {number}
 */
var getTimestamp = exports.getTimestamp = function getTimestamp() {
  return Date.now();
};

/**
 * Takes in the children property of a node object and returns an array that is the
 * result of iterating through each nodes children property and adding it to the same
 * array, thus flattening the children property of each node object into a single array.
 *
 * @param {Node[]} children array of node objects
 * @returns Array of nodes which are now located at the same level
 */
function flatten(children) {
  var _reducer = function reducer(acc, childNode) {
    var _childNode$children;
    acc.push(childNode);
    if (childNode !== null && childNode !== void 0 && (_childNode$children = childNode.children) !== null && _childNode$children !== void 0 && _childNode$children.length) {
      return childNode.children.reduce(_reducer, acc);
    }
    return acc;
  };
  return children.reduce(_reducer, []);
}

/**
 * Transforms content URLs
 * @param url {String}
 * @return {String}
 */
function urlTransformer(url) {
  return /^\/content\/dam/.test(url) ? "https://content.nike.com".concat(url) : url;
}